import React from 'react';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

function YearOverYearHeader({ selectedYear }) {
  const years = React.useMemo(
    () => ({
      current: selectedYear,
      previous: selectedYear - 1,
    }),
    [selectedYear]
  );

  return (
    <TableRow>
      <TableCell data-cy="bucket-column" variant="head">
        Bucket
      </TableCell>
      <TableCell data-cy="previous-column" variant="head">
        {years.previous}
      </TableCell>
      <TableCell data-cy="current-column" variant="head">
        {years.current}
      </TableCell>
      <TableCell data-cy="change-column" variant="head">
        Change
      </TableCell>
    </TableRow>
  );
}
export default React.memo(YearOverYearHeader);
